(function () {
  function init(root) {
    root.querySelectorAll('[data-asos-care-coupon]').forEach(function (card) {
      if (card.dataset.careInitialized) return;
      card.dataset.careInitialized = 'true';
      function checkDates() {
        var now = Date.now();
        card.hidden = now < Date.parse(card.dataset.start) || now > Date.parse(card.dataset.end);
      }
      checkDates();
      document.addEventListener('visibilitychange', checkDates);
      var remaining = Date.parse(card.dataset.end) - Date.now();
      if (remaining >= 0 && remaining < 2147483647) setTimeout(checkDates, remaining + 1000);
      var button = card.querySelector('[data-care-copy]');
      var label = button.textContent;
      button.addEventListener('click', async function () {
        button.disabled = true;
        var copied = false;
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(button.dataset.careCopy);
            copied = true;
          }
        } catch (error) {}
        if (!copied) {
          var field = document.createElement('textarea');
          field.value = button.dataset.careCopy;
          field.setAttribute('readonly', '');
          field.style.position = 'fixed';
          field.style.opacity = '0';
          document.body.appendChild(field);
          field.select();
          try { copied = document.execCommand('copy'); } catch (error) {}
          field.remove();
          button.focus({preventScroll: true});
        }
        button.textContent = copied ? 'Cupom copiado!' : 'Toque para tentar novamente';
        button.disabled = false;
        setTimeout(function () { button.textContent = label; }, 2500);
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
